import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

// Replace YOUR_FILE_ID below with your Google Drive PDF file ID
const CATALOG_URL = "https://drive.google.com/uc?export=download&id=1BqHySRqQlC45ob3hBgjCCSDseqE7IrAW";

const navItems = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Brands", to: "/brands" },
  { label: "Services", to: "/services" },
  { label: "Markets", to: "/markets" },
  { label: "News", to: "/news" },
  { label: "Contact", to: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const hasBg = scrolled || !isHome;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        hasBg
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-full font-label font-semibold tracking-wider text-sm ${
              hasBg ? "bg-primary-500 text-background-50" : "bg-background-50 text-primary-500"
            }`}
          >
            GH
          </span>
          <span
            className={`font-heading text-2xl font-semibold tracking-tight ${
              hasBg ? "text-foreground-950" : "text-background-50"
            }`}
          >
            GH
          </span>
        </Link>

        <ul className="hidden lg:flex items-center gap-9">
          {navItems.map((it) => {
            const isActive = location.pathname === it.to;
            return (
              <li key={it.to}>
                <Link
                  to={it.to}
                  className={`text-[13px] font-label tracking-[0.14em] uppercase cursor-pointer transition-colors ${
                    isActive
                      ? "text-accent-500"
                      : hasBg
                        ? "text-foreground-700 hover:text-accent-500"
                        : "text-background-50/90 hover:text-accent-300"
                  }`}
                >
                  {it.label}
                </Link>
              </li>
            );
          })}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={CATALOG_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap cursor-pointer px-5 py-2.5 rounded-full border-2 font-label text-[13px] tracking-[0.12em] uppercase flex items-center gap-2 transition-all"
            style={{
              borderColor: hasBg ? 'oklch(var(--accent-500))' : 'oklch(1 0 0 / 0.85)',
              color: hasBg ? 'oklch(var(--accent-700))' : 'oklch(1 0 0)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = hasBg ? 'oklch(var(--accent-500))' : 'oklch(1 0 0 / 0.2)';
              e.currentTarget.style.color = hasBg ? 'oklch(var(--background-50))' : 'oklch(1 0 0)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = hasBg ? 'oklch(var(--accent-700))' : 'oklch(1 0 0)';
            }}
          >
            <i className="ri-download-line w-4 h-4 flex items-center justify-center" />
            <span>Catalog</span>
          </a>
          <Link
            to="/contact"
            className="gh-shimmer-btn whitespace-nowrap cursor-pointer px-5 py-2.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600 transition-colors font-label text-[13px] tracking-[0.12em] uppercase flex items-center gap-2"
          >
            <span>Send Inquiry</span>
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer ${
            hasBg ? "text-foreground-950 bg-background-100" : "text-background-50 bg-foreground-950/30"
          }`}
          aria-label="Toggle menu"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <ul className="flex flex-col py-4 px-6">
            {navItems.map((it) => (
              <li key={it.to}>
                <Link
                  to={it.to}
                  onClick={() => setMobileOpen(false)}
                  className={`block py-3 font-label text-sm tracking-wider uppercase cursor-pointer ${
                    location.pathname === it.to ? "text-accent-500" : "text-foreground-700 hover:text-accent-500"
                  }`}
                >
                  {it.label}
                </Link>
              </li>
            ))}
            <li className="pt-3">
              <a
                href={CATALOG_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMobileOpen(false)}
                className="whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 px-5 py-3 rounded-full border-2 border-accent-500 text-accent-700 font-label text-sm tracking-wider uppercase"
              >
                <i className="ri-download-line" />
                Catalog
              </a>
            </li>
            <li className="pt-3">
              <Link
                to="/contact"
                onClick={() => setMobileOpen(false)}
                className="gh-shimmer-btn whitespace-nowrap cursor-pointer block text-center px-5 py-3 rounded-full bg-primary-500 text-background-50 font-label text-sm tracking-wider uppercase"
              >
                Send Inquiry
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}